<template>
  <a-result v-if="saveSuccess" status="success" title="提交成功">
    <template #extra>
      <a-button key="console" type="primary" @click="returnList">返回列表</a-button>
      <a-button key="buy" @click="detail">查看详情</a-button>
      <a-button @click="continueCreate">+ 继续新建</a-button>
    </template>
  </a-result>
  <a-result v-else status="error" title="提交失败" sub-title="系统遇到异常问题导致提交失败，请重试">
    <template #extra>
      <a-button type="primary" @click="resubmit">重新提交</a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  props:['returnList','saveSuccess','recordId'],
  data(){
    return{}
  },
  watch: {
  '$route': function() {
      window.location.reload();
    }
  },
  methods:{
    continueCreate(){
      this.$router.push({
        path: '/empirical-data/pig/pig-new-data',
        query: {
          name: '猪线路新建',
        }
      })
      window.location.reload()
    },
    detail(){
      this.$router.push({
        path: '/empirical-data/pig/pig-detail',
        query: {
          name: '猪线路详情',
          id: this.recordId,
        }
      })
    },
    resubmit(){
      this.$emit('saveData')
    },
  }
}
</script>

<style>

</style>